export enum WarningLevel {
  None = "none",
  Warning = "warning",
  Danger = "danger",
}
